import moment from 'moment';
import { Button } from 'primereact/button';
import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';

function NewsItem({ news, handleClickNews, handleDuplicateNews }) {
  return (
    <div
      className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100 w-full h-44"
      onClick={handleClickNews}>
      <img
        className="h-32 w-32 object-cover shadow-md block rounded-md"
        src={news.image ? news.image.file : getImage('img-ph.png')}
        alt={news.image ? news.image.label : 'Non renseignée'}
      />
      <div className="flex flex-col justify-around h-full w-full">
        <div className="flex flex-col gap-y-1">
          <div className="text-xl font-bold text-slate-700 ">{news.title}</div>
          <span className="font-medium text-slate-700">
            {moment(news.publication_date).format('LL')}
          </span>
        </div>
        <div className="flex flex-row gap-x-3">
          <Tag
            tag={{
              label: getConstant('bassecour.newsTypes', news.type).label,
              icon: 'star',
              bgColor: 'bg-sky-950'
            }}
          />
        </div>
      </div>
      <Button
        rounded
        icon="pi pi-clone"
        className="min-h-12 min-w-12"
        tooltip="Dupliquer l'article"
        tooltipOptions={{ position: 'left' }}
        onClick={handleDuplicateNews}
        severity="secondary"
        outlined
      />
    </div>
  );
}

export default NewsItem;
